import {handleActions} from 'redux-actions';
import {StudentList} from '../../constants/models';

const studentListReducers = handleActions({
    GET_STUDENT_LIST_SUCCESS: (state, {payload}) => (
        state.merge({
            data: payload.data
        })
    ),
    CHAGE_STUD_BIRTHDAY: (state, {payload}) => (
        state.merge({
        data: payload
    })
    ),
}, StudentList);

export default studentListReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/student_list/studentListReducers.jsx